import { cn } from '@/lib/utils'

export const FIELD_CLASS_NAME = cn(
  'w-full rounded-xl border border-[var(--field-border)] bg-[var(--field-bg)] px-3.5 text-sm text-[var(--text-strong)]',
  'placeholder:text-[var(--surface-muted)]',
  'focus:border-[var(--color-brand-accent)] focus:outline-none focus:ring-2 focus:ring-[var(--color-brand-accent)]/35',
  'disabled:cursor-not-allowed disabled:bg-[var(--surface-card-hover)] disabled:opacity-70',
  'aria-invalid:border-red-400 aria-invalid:focus:ring-red-400/35',
)

export function describedBy(...ids: (string | undefined)[]) {
  const value = ids.filter(Boolean).join(' ')
  return value || undefined
}
